import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null,
    error: false
};

const route = "devices/.components/maintenanceWarnings/.components/deleteMaintenanceWarningEvent/redux/slice";

export const deleteMaintenanceWarningsEvents = createAsyncThunk("devices/.components/maintenanceWarnings/.components/confirmResolveMaintenanceWarningEvent/redux/slice/deleteMaintenanceWarningsEvents", async (payload, { rejectWithValue, dispatch }) => {
    const { dateRange, unitId, warning } = payload
    try {
        let response = await clientMutation(`
            mutation deleteMaintenanceWarningEvents($unitId: Int!, $warning: String, $dateRange: AWSDateTimeRange!) {
                result: deleteMaintenanceWarningEvents(unitId: $unitId, warning: $warning, dateRange: $dateRange)
            }`,
            {
                unitId: unitId,
                warning: warning,
                dateRange: dateRange
            },
            endpoints.GRAPHQL_GENERAL
        )
        return { delete: response?.result }

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'deleteMaintenanceWarningsEvents');
        return rejectWithValue(exc);
    }
})

export const maintenanceWarningsDeleteRedux = createSlice({
    name: 'devices/maintenanceWarnings/resolveMaintenanceWarningEvent',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalDeleteMaintenanceWarningEvent(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(deleteMaintenanceWarningsEvents.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(deleteMaintenanceWarningsEvents.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });
        builder.addCase(deleteMaintenanceWarningsEvents.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = maintenanceWarningsDeleteRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalDeleteMaintenanceWarningEvent
} = actions;

export default reducer;
